var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShootproofLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.205 0h-5.001l2.172 2.2h2.83c.31 0 .62.313.62.63v2.864L26 7.894V2.83C26 1.257 24.447 0 23.205 0zM0 2.83v5.064l2.174-2.2V2.83c0-.317.312-.63.62-.63h2.83L7.797 0H2.794C1.243 0 0 1.572 0 2.83zM2.794 20h5.003l-2.173-2.2h-2.83c-.308 0-.62-.315-.62-.63v-2.864L0 12.106v5.063C0 18.741 1.553 20 2.794 20zM26 12.106v5.063C26 18.427 24.759 20 23.205 20h-5.001l2.172-2.2h2.83c.31 0 .62-.315.62-.63v-2.863l2.174-2.2z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.205 0h-5.001l2.172 2.2h2.83c.31 0 .62.313.62.63v2.864L26 7.894V2.83C26 1.257 24.447 0 23.205 0zM0 2.83v5.064l2.174-2.2V2.83c0-.317.312-.63.62-.63h2.83L7.797 0H2.794C1.243 0 0 1.572 0 2.83zM2.794 20h5.003l-2.173-2.2h-2.83c-.308 0-.62-.315-.62-.63v-2.864L0 12.106v5.063C0 18.741 1.553 20 2.794 20zM26 12.106v5.063C26 18.427 24.759 20 23.205 20h-5.001l2.172-2.2h2.83c.31 0 .62-.315.62-.63v-2.863l2.174-2.2z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M-3-6h32v32H-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShootproofLogo);
export default __webpack_public_path__ + "static/media/shootproof-logo.350078bd1d95c919358930660c57e1ca.svg";
export { ForwardRef as ReactComponent };